import { combineReducers } from "redux"
import discoveryJobsFilter from "./discoveryJobsFilter"
import createListWithNameReducer from "js/state/reducers/createListWithNameReducer"

export default combineReducers({
  discoveryJobsList: createListWithNameReducer("DISCOVERY_JOBS"),
  discoveryJobsHistory: createListWithNameReducer("DISCOVERY_JOBS_HISTORY"),
  discoveryJobsFilter,
})
